export default __webpack_public_path__ + "static/1Oxygen-Home-Loans-Lending-Guidelines-Final-ea6306a94bcfd06a05760baab7d84108.pdf";